import React from 'react';
import { useTranslation } from 'react-i18next';
import SEO from '../../components/SEO/SEO';
import PageHeader from '../../components/PageHeader/PageHeader';
import styles from './Legals.module.css';

const DataTreatment = () => {
  const { t, i18n } = useTranslation();
  const isEn = i18n.language === 'en';

  return (
    <div className={styles.legalsPage}>
      <SEO
        title={t('seo.dataTitle')}
        description={t('legals.dataDesc')}
        canonicalPath={`/${isEn ? 'data-management' : 'tratamiento-datos'}`}
      />

      <PageHeader
        title={t('legals.dataTitle')}
        description={t('legals.dataDesc')}
      />

      <section className="container">
        <div className={styles.legalsContent}>
          <div>
            <p>
              De conformidad con lo dispuesto en la Ley 1581 de 2012 y el Decreto Reglamentario 1377 de 2013 (o normativas aplicables en su jurisdicción), CINBIOSIS establece el siguiente manual interno de políticas y procedimientos para garantizar el adecuado cumplimiento de la ley y, en especial, para la atención de consultas y reclamos acerca del tratamiento de los datos personales.
            </p>

            <h2>1. Finalidad del Tratamiento</h2>
            <p>
              Los datos personales suministrados serán recolectados y tratados para los siguientes fines asociados a nuestra actividad económica:
            </p>
            <ul>
              <li>Elaboración de diagnósticos ambientales e informes técnicos.</li>
              <li>Envío de facturas, cotizaciones y comunicaciones comerciales.</li>
              <li>Contacto a proveedores para adquisición de insumos técnicos y de campo.</li>
            </ul>

            <h2>2. Derechos de los titulares</h2>
            <p>Como titular de sus datos personales usted tiene derecho a:</p>
            <ul>
              <li>Conocer, actualizar y rectificar sus datos personales.</li>
              <li>Solicitar prueba de la autorización otorgada a la Empresa.</li>
              <li>Ser informado respecto del uso que le ha dado a sus datos.</li>
              <li>Revocar la autorización y/o solicitar la supresión del dato.</li>
            </ul>

            <h2>3. Procedimientos de atención</h2>
            <p>
              Los titulares pueden enviar sus Peticiones, Quejas o Reclamos (PQR) al correo electrónico <strong>ventas@cinbiosis.com</strong> indicando detalladamente el requerimiento de información o actualización.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default DataTreatment;
